var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "DeleteText",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <g id="svg-fg">
    <path d="M43.87,38.45a.72.72,0,0,1-.42-.14,1.84,1.84,0,0,1-.25-.22l-4.82-4.94-4.82,4.94a.89.89,0,0,1-.66.35l-.16,0a.77.77,0,0,1-.58-.51.82.82,0,0,1,.14-.8l.15-.16L37.27,32l-4.8-4.92a.91.91,0,0,1-.33-.87.78.78,0,0,1,.76-.65.74.74,0,0,1,.49.19l.14.14,4.85,5,4.87-5a.81.81,0,0,1,.6-.3l.2,0a.76.76,0,0,1,.54.48.8.8,0,0,1-.08.75,1.87,1.87,0,0,1-.22.26L39.5,32l4.86,5a.85.85,0,0,1,.27.85A.77.77,0,0,1,43.87,38.45Z"/>
    <path d="M32.9,26.08a.24.24,0,0,1,.16.07l.12.12,0,0,3.52,3.61.92.95.72.73.72-.73.94-1,3.57-3.66c.14-.15.22-.15.24-.15h.09a.27.27,0,0,1,.18.17.31.31,0,0,1,0,.29,1.44,1.44,0,0,1-.16.19l-4.46,4.57-.68.7.68.7.86.88L44,37.34c.17.18.17.27.14.39a.28.28,0,0,1-.26.22.21.21,0,0,1-.13,0l-.18-.16L39.1,33.17l-.72-.73-.72.73-1,1-3.44,3.52c-.13.13-.23.2-.3.2h-.06a.27.27,0,0,1-.21-.19.32.32,0,0,1,.06-.32l.11-.12,0,0,4.45-4.55L38,32l-.68-.7-1-1.05-3.44-3.52c-.23-.24-.21-.34-.2-.42a.28.28,0,0,1,.27-.24m0-1a1.28,1.28,0,0,0-1.25,1.05,1.41,1.41,0,0,0,.46,1.31L36.57,32l-4.45,4.55-.21.22a1.31,1.31,0,0,0,.72,2.13l.26,0a1.41,1.41,0,0,0,1-.5l4.46-4.57,4.46,4.57a2.38,2.38,0,0,0,.32.28,1.21,1.21,0,0,0,.71.23,1.28,1.28,0,0,0,1.24-1,1.34,1.34,0,0,0-.4-1.3L40.2,32l4.46-4.57a2.4,2.4,0,0,0,.27-.33,1.31,1.31,0,0,0-.76-2,1.38,1.38,0,0,0-.31,0,1.32,1.32,0,0,0-1,.45l-4.51,4.62L33.94,25.6l-.21-.21a1.24,1.24,0,0,0-.82-.32Z"/>
    <path d="M51.15,37.58c0-.05,0-.11,0-.16,0-5-.05-10.09,0-15.14a3.27,3.27,0,0,0-3.3-3.37c-7.76,0-15.52,0-23.29,0a1.71,1.71,0,0,0-1.39.64q-4.89,5.67-9.81,11.32a1.4,1.4,0,0,0,0,2.26c3.18,3.67,6.38,7.32,9.53,11a2.49,2.49,0,0,0,2.1,1c7.55,0,15.09,0,22.64,0a7.43,7.43,0,0,0,.83,0,3.06,3.06,0,0,0,2.67-3h0Zm-3.33,4.89c-7.49,0-15,0-22.46,0a1.14,1.14,0,0,1-.74-.35c-.81-.88-1.58-1.8-2.37-2.7L15.85,32c.15-.19.25-.33.37-.46q4.2-4.84,8.42-9.67a1.19,1.19,0,0,1,.81-.33q11.14,0,22.28,0c.82,0,.85,0,.85.89q0,7.25,0,14.51h0V42C48.48,42.37,48.24,42.47,47.83,42.47Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/delete_text.svg